'use client'
import {
  useBooking_default
} from "./chunk-NFYYQXAH.mjs";
import {
  getEventStatus
} from "./chunk-HGCJUMLB.mjs";
import {
  __async
} from "./chunk-BTG5EALA.mjs";

// src/hooks/soldout.ts
import { useCallback, useEffect, useState } from "react";
var useSoldout = () => {
  const { event, chart, isSeated } = useBooking_default();
  const [soldout, setSoldout] = useState();
  const checkSoldout = useCallback(() => __async(void 0, null, function* () {
    try {
      if (isSeated && !chart) {
        return;
      }
      const status = getEventStatus(event);
      setSoldout(status.disabled);
    } catch (error) {
    }
  }), [chart, event, isSeated]);
  useEffect(() => {
    checkSoldout();
  }, [checkSoldout]);
  return {
    mounted: typeof soldout === "boolean",
    soldout
  };
};
var soldout_default = useSoldout;

export {
  soldout_default
};
//# sourceMappingURL=chunk-VUVIFRCT.mjs.map